import React from 'react';
import { Typography } from '@material-ui/core';
import { Check, Close } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import { useSupplyIntakeSectionStyles } from '../styles/SupplyIntakeSection.styles';
import { dayNames, getTruncatedTextProps } from '../common/utils';

interface SupplyIntakeSectionProps {
  deliveryDays: string[];
  recentlyEditedDeliveryDays?: string[];
}

function SupplyIntakeSection({
  deliveryDays,
  recentlyEditedDeliveryDays = [],
}: SupplyIntakeSectionProps) {
  const classes = useSupplyIntakeSectionStyles();
  const { t } = useTranslation();

  const isSupplyIntakeDay = (dayIndex: number): boolean => {
    if (!deliveryDays || deliveryDays.length === 0) return false;

    const dayName = dayNames[dayIndex];
    // Map Monday-Sunday display order to the deliveryDays format (1-Sunday, 2-Monday, etc.)
    const dayNumber = dayIndex === 6 ? 1 : dayIndex + 2; // Sunday (index 6) is 1, Monday (index 0) is 2, etc.
    const dayKey = `${dayNumber} - ${dayName}`;

    return deliveryDays.includes(dayKey);
  };

  /**
   * Check if a day was recently edited (added or removed)
   * @param dayIndex - Index of the day in the week (0 = Monday, 6 = Sunday)
   * @returns true if the day was recently changed
   */
  const isRecentlyEditedDay = (dayName: string): boolean => {
    if (!recentlyEditedDeliveryDays || recentlyEditedDeliveryDays.length === 0)
      return false;

    return recentlyEditedDeliveryDays.includes(dayName);
  };

  return (
    <div className={classes.sectionContainer}>
      <div className={classes.weekGrid}>
        {dayNames.map((dayName, dayIndex) => {
          const isIntakeDay = isSupplyIntakeDay(dayIndex);
          const isRecentlyEdited = isRecentlyEditedDay(dayName);

          return (
            <div
              key={`supply-intake-${dayIndex}`}
              className={`${classes.dayCardGray} ${isRecentlyEdited ? classes.highlightedCard : ''}`}
            >
              <div className={classes.dayContent}>
                {(() => {
                  const deliveryDaysText = t(
                    'operationHours.truckDeliveryDays',
                  ) as string;
                  const { displayText, tooltipTitle } =
                    getTruncatedTextProps(deliveryDaysText);
                  return (
                    <Typography
                      className={`${classes.serviceName} ${classes.serviceNameWithIcon}`}
                      title={tooltipTitle}
                    >
                      {displayText}
                    </Typography>
                  );
                })()}
                {isIntakeDay ? (
                  <Check fontSize="small" className={classes.checkIcon} />
                ) : (
                  <Close fontSize="small" className={classes.closeIcon} />
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default SupplyIntakeSection;
